import React from 'react';

export default class Axis extends React.Component {
    componentWillMount() {
        this.prepareCords(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.prepareCords(nextProps);
    }

    prepareCords(values) {
        const x2 = values.x + (values.horizontal ? values.length : 0),
              y2 = values.y - (values.horizontal ? 0 : values.length);

        this.setState({
            textAnchor: (values.horizontal ? 'middle' : 'end'),
            zero: values.margin / values.multiplier,
            max: (values.margin + values.length) / values.multiplier,
            coords: {
                x1: values.x,
                y1: values.y,
                x2: x2,
                y2: y2,
            },
            coordsText: {
                x1: values.x - (values.horizontal ? 0 : 5),
                y1: values.y + (values.horizontal ? 18 : 0),
                x2: x2 - (values.horizontal ? 0 : 5),
                y2: y2 + (values.horizontal ? 18 : 0),
            }
        }, () => this.prepareAxis(values));
    }

    prepareAxis(values) {
        let axis = [],
            lines = [],
            val = 0,
            distanceX = Math.round((this.state.coordsText.x2 - this.state.coordsText.x1) / (this.state.max - this.state.zero)),
            distanceY = Math.round((this.state.coordsText.y1 - this.state.coordsText.y2) / (this.state.max - this.state.zero)),
            distanceZero = Math.round(values.multiplier * (this.state.zero % 1)),
            skip = values.multiplier > 20 ? 0 : values.multiplier > 10 ? 1 : values.multiplier > 5 ? 2 : values.multiplier > 2 ? 3 : 4;

        distanceZero = distanceZero < 0 ? Math.abs(values.multiplier + distanceZero) : distanceZero;
        for (let i = 1; i < (this.state.max - this.state.zero) - (values.horizontal ? 0.5 : 0.3); i++) {
            val = i + Math.floor(this.state.zero);
            if (skip === 0 || (skip === 1 && !(val%2)) || (skip === 2 && !(val%5)) || (skip === 3 && !(val%10)) || (skip === 4 && !(val%50))) {
                if (!(i === 1 && (distanceZero > 10))) {
                    lines = this.prepareLines(values, i, distanceX, distanceY, distanceZero, false);
                    axis.push(
                        <g key={"axisLabelG" + i + values.horizontal}>
                            <text //key={"axisLabel" + i + values.horizontal}
                                  textAnchor={this.state.textAnchor}
                                  x={this.state.coordsText.x1 + (distanceX * i) - (values.horizontal ? distanceZero : 0)}
                                  y={this.state.coordsText.y1 - (distanceY * i) + (values.horizontal ? 0 : distanceZero)}
                                  >
                                {val}
                            </text>
                            {lines}
                        </g>
                    );
                } else {
                    lines = this.prepareLines(values, i, distanceX, distanceY, distanceZero, true);
                    axis.push(<g key={"axisLabelG" + i + values.horizontal}>{lines}</g>);
                }
            }
        }
        this.setState({
            axis: axis,
        })
    }

    prepareLines(values, i, distanceX, distanceY, distanceZero, justBackground) {
        let bckgLine = '';
        if (!values.horizontal) {
            bckgLine = (
                <line
                    x1={this.state.coords.x1}
                    y1={this.state.coords.y1 - distanceY * i + distanceZero}
                    x2={values.width}
                    y2={this.state.coords.y1 - distanceY * i + distanceZero}
                    stroke="rgba(0, 0, 0, .1)"
                    strokeWidth={1}
                />
            );
        }
        if (justBackground) {
            return bckgLine;
        } else {
            return (
                <g>
                    <line
                        x1={this.state.coords.x1 + distanceX * i - (values.horizontal ? distanceZero : 5)}
                        y1={this.state.coords.y1 - distanceY * i + (values.horizontal ? 5 : distanceZero)}
                        x2={this.state.coords.x1 + distanceX * i - (values.horizontal ? distanceZero : 0)}
                        y2={this.state.coords.y1 - distanceY * i + (values.horizontal ? 0 : distanceZero)}
                        stroke="black"
                        strokeWidth={1}
                    />
                    {bckgLine}
                </g>
            )
        }
    }

    render() {
        return (
            <g>
                <line {...this.state.coords} stroke="black" strokeWidth={2}/>
                <text textAnchor={this.state.textAnchor} x={this.state.coordsText.x1} y={this.state.coordsText.y1}>{Math.round(this.state.zero*10)/10}</text>
                <text textAnchor={this.state.textAnchor} x={this.state.coordsText.x2} y={this.state.coordsText.y2}>{Math.round(this.state.max*10)/10}</text>
                {this.state.axis}
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/graph-components/axis.js